/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RaceClass } from '../../models/race-class';

export interface PostRaceClasses$Params {
      body: Array<RaceClass>
}

export function postRaceClasses(http: HttpClient, rootUrl: string, params: PostRaceClasses$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RaceClass>>> {
  const rb = new RequestBuilder(rootUrl, postRaceClasses.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<RaceClass>>;
    })
  );
}

postRaceClasses.PATH = '/classes';
